import * as React from "react";
import SingleSelect from "../../../../components/commonComponents/Selectors/SingleSelect";
import { useDispatch, useSelector } from "react-redux";
import { checkUserRole } from "../../../../api_calls/userManagement";
import { updateStateData } from "../../../../Store/actions";

export default function AnalysisGroupSingle({ redux_param_name, multiSelect, reduxKeywordToSaveValue }) {
  const userStateData = useSelector((state) => state.userSelections);
  const dispatchAction = useDispatch();
  const [selectedAnalysisGroup, setAnalysisGroup] = React.useState({});
  const [dataLoaded, setDataLoaded] = React.useState(false);
  const userRole = userStateData?.brand_report_view === true ? { user_role: "Brand" } : checkUserRole();

  let adlevelNames =
    typeof userStateData.adlevel_names !== "undefined" && userStateData.adlevel_names.length !== 0
      ? [
          ...userStateData.adlevel_names.map((adlevelInfo) => {
            return adlevelInfo.label;
          }),
        ]
      : [];

  if (userRole.user_role === "Brand") {
    adlevelNames = userStateData?.brand_filters?.performance_filter?.analysis_group
      ? multiSelect
        ? [...userStateData.brand_filters.performance_filter.analysis_group]
        : [...userStateData.brand_filters.performance_filter.analysis_group].filter((item) => item !== "(All)")
      : [];
  }

  const seededValues =
    typeof userStateData[reduxKeywordToSaveValue] !== "undefined" &&
    typeof userStateData[reduxKeywordToSaveValue][redux_param_name] !== "undefined"
      ? userStateData[reduxKeywordToSaveValue][redux_param_name]
      : null;

  React.useEffect(() => {
    // Prefer page-load seed (single-element array); else first available group.
    let defaultSelection = "";
    if (Array.isArray(seededValues) && seededValues.length !== 0) {
      defaultSelection = seededValues.find((item) => item !== "(All)") || seededValues[0];
    } else if (adlevelNames.length !== 0) {
      defaultSelection = adlevelNames.find((item) => item !== "(All)") || adlevelNames[0];
    }

    setAnalysisGroup({ value: defaultSelection, label: defaultSelection });

    // Ensure Redux holds a one-element array so Embeddable does not wait for user change.
    if (defaultSelection !== "") {
      const alreadySeeded =
        Array.isArray(seededValues) &&
        seededValues.length === 1 &&
        seededValues[0] === defaultSelection;

      if (!alreadySeeded) {
        dispatchAction(
          updateStateData({
            [reduxKeywordToSaveValue]: {
              ...userStateData[reduxKeywordToSaveValue],
              [redux_param_name]: [defaultSelection],
            },
          })
        );
      }
    }

    setTimeout(() => {
      setDataLoaded(true);
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userRole.user_role]);

  return dataLoaded ? (
    <SingleSelect
      enableFullWidth={true}
      label={"Analysis Group"}
      sortOptions={false}
      selectionCheck={(option, value) => option.label === value.label}
      options={adlevelNames.map((groupName) => {
        return { value: groupName, label: groupName };
      })}
      defaultVal={selectedAnalysisGroup}
      onChangeCall={(selectedOption) => {
        let selectAdlevels = [];
        setAnalysisGroup({ value: selectedOption.value, label: selectedOption.value });
        if (selectedOption.value.includes("(All)")) {
          selectAdlevels = adlevelNames;
        } else {
          selectAdlevels = [selectedOption.value];
        }
        dispatchAction(
          updateStateData({
            [reduxKeywordToSaveValue]: {
              ...userStateData[reduxKeywordToSaveValue],
              [redux_param_name]: selectAdlevels,
            },
          })
        );
      }}
    />
  ) : (
    <></>
  );
}
